/**
 * Utility for extracting texture token from initial request headers
 * This handles the client-side extraction and storage of texture tokens
 */

/**
 * Store texture token for use across the application
 * This provides a secure way to maintain the token during the session
 */
export function storeTextureToken(token) {
  if (!token) return;

  try {
    // Store in a secure way that's cleared on page reload
    sessionStorage.setItem('activeTextureToken', token);
  } catch (e) {
    console.debug('Could not store texture token:', e);
  }
}

/**
 * Retrieve the stored texture token
 */
export function getStoredTextureToken() {
  try {
    return sessionStorage.getItem('activeTextureToken');
  } catch (e) {
    console.debug('Could not retrieve texture token:', e);
    return null;
  }
}

/**
 * Clear the stored texture token
 */
export function clearStoredTextureToken() {
  try {
    sessionStorage.removeItem('activeTextureToken');
    sessionStorage.removeItem('textureToken'); // Also clear any initial token
  } catch (e) {
    console.debug('Could not clear texture token:', e);
  }
}
